import React from 'react';
import Gauge from 'react-svg-gauge';

function SentimentGauge({ sentiment, value }) {
    // Define color mappings for sentiment values
    const colorMap = {
      POSITIVE: '#00C853',
      NEGATIVE: '#FF1744',
      NEUTRAL: '#3D5AFE',
    };
  
    return (
      <div style={{ width: '100%', textAlign: 'center', marginTop: 10 }}>
        <Gauge
          value={value}
          width={200}
          height={150}
          color={colorMap[sentiment]}
          label={sentiment}
        />
      </div>
    );
  }
  export default SentimentGauge;